interface HeroListener {
  onShowHtml: (payload: { html: HTMLElement }) => Promise<void>;
  onShowCmp: (payload: {
    html: HTMLElement;
    cmp: any;
    data: any;
  }) => Promise<void>;
  onHide: () => Promise<void>;
}

export const useHero = (() => {
  let _listener: HeroListener;
  const setRootListener = (listener: HeroListener) => {
    _listener = listener;
  };

  const showHtml = (payload: { html: HTMLElement }) => {
    _listener.onShowHtml(payload);
  };

  const showCmp = (payload: { html: HTMLElement; cmp: any; data: any }) => {
    _listener.onShowCmp(payload);
  };

  return { setRootListener, showHtml, showCmp };
})();
